export const pmTicketSignalLevelsFormConfig = {
    fields: [{
        name: 'Tap High Ch RF Level',
        id: 'tapHigh',
    }, {
        name: 'Tap Low Ch RF Level',
        id: 'tapLow',
    }, {
        name: 'Tap DOCSIS RX',
        id: 'tapRx',
    }, {
        name: 'Tap DOCSIS TX',
        id: 'tapTx',
    }, {
        name: 'NID High Ch RF Level',
        id: 'groundBlockHigh',
    }, {
        name: 'NID Low Ch RF Level',
        id: 'groundBlockLow',
    }, {
        name: 'NID DOCSIS RX',
        id: 'groundBlockRx',
    }, {
        name: 'NID DOCSIS TX',
        id: 'groundBlockTx',
    }]
};



// WEBPACK FOOTER //
// ./src/constants/pmTicketSignalLevelsFormConfig.js